const createOrUpdateUserIntermediateDetailsGraphQlMutation = (
  withMutation = true
): { mutation: string; type: string } => {
  const failureFields = `
      failure_response {
        res_status
        response
      }
    `;

  const successFields = `
      completion_percentage
    `;

  const mutation = `create_or_update_user_intermediate_details(user_intermediate_details_input: $user_intermediate_details_input) {
          ${successFields}
          ${failureFields}
        }`;

  if (withMutation)
    return {
      mutation: `
      mutation CreateOrUpdateUserIntermediateDetails($user_intermediate_details_input: UserIntermediateDetailsInput!) {
        ${mutation}
      }
    `,
      type: 'CreateOrUpdateUserIntermediateDetailsMutationResponse!'
    };
  else {
    return {
      mutation,
      type: 'UserIntermediateDetailsInput!'
    };
  }
};

export { createOrUpdateUserIntermediateDetailsGraphQlMutation };
